
/**
 * PropertyTextField - Reusable text input field for garden object properties
 *
 * @param {string} label - Field label
 * @param {string} value - Current value
 * @param {function} onChange - Callback(newValue) when value changes
 * @param {string} placeholder - Optional placeholder text
 * @param {boolean} disabled - Whether field is disabled
 */
const PropertyTextField = ({
  label,
  value,
  onChange,
  placeholder = '',
  disabled = false,
}) => {
  return (
    <div>
      <label className="block text-xs font-medium text-gray-600 mb-1">
        {label}
      </label>
      <input
        type="text"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        className="w-full px-3 py-2 text-sm border border-gray-300 rounded
          focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500
          disabled:bg-gray-100 disabled:cursor-not-allowed"
      />
    </div>
  );
};

export default PropertyTextField;
